module.exports = __webpack_public_path__ + "img/203-Gris Argent.jpg";